'use client';

import { c as _c } from "react/compiler-runtime";
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { StepCard, ThreeStepCardsLayout } from '@algoacademy/design-system/web/marketing/layouts/StepCards';
import { H2 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { ScholarshipApplyButton } from '../_forms/ScholarshipApplicationForm';
import { ConsultantInLaptop } from '../_svg/ConsultantInLaptop';
import { FillingForm } from '../_svg/FillingForm';
import { PhoneMeeting } from '../_svg/PhoneMeeting';
export function ApplySection() {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <H2>Aplikuj o stypendium AlgoAcademy</H2>;
    t1 = <VerticalSpacer size="content" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <StepCard number={1} title={"Wype\u0142nij wniosek"} illustration={<FillingForm />} content={"Wype\u0142nij formularz, w kt\xF3rym opowiesz o sobie i swoich celach. Prowadzimy ci\u0105g\u0142y nab\xF3r - mo\u017Cesz aplikowa\u0107 w dowolnym momencie. O wyniku pierwszego etapu poinformujemy Ci\u0119 w ci\u0105gu dw\xF3ch tygodni od z\u0142o\u017Cenia wniosku."} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <StepCard number={2} title={"Zaprezentuj si\u0119"} illustration={<PhoneMeeting />} content={"Po zakwalifikowaniu si\u0119 do tego przygotowujesz kr\xF3tk\u0105 prezentacj\u0119 o sobie. Zaprezentujesz j\u0105 przed za\u0142o\u017Cycielami AlgoAcademy. O wynikach tego etapu poinformujemy Ci\u0119 tego samego dnia."} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="text-center">{t0}{t1}<ThreeStepCardsLayout>{t2}{t3}<StepCard number={3} title="Wybierz mentora" illustration={<ConsultantInLaptop />} content={"Je\u015Bli uda\u0142o Ci si\u0119 dotrze\u0107 do tego etapu - serdecznie gratulujemy! Um\xF3wimy Ci\u0119 na rozmow\u0119 z mentorami - zdecydujesz, kt\xF3ry b\u0119dzie Twoim przewodnikiem przez kolejne p\xF3\u0142 roku. Po wyborze mentora ustalacie razem harmonogram i zaczynacie!"} /></ThreeStepCardsLayout><VerticalSpacer size="button" /><ScholarshipApplyButton size="xl" className="w-full lg:w-fit">Złóż wniosek o stypendium</ScholarshipApplyButton></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}